import { 
    useEffect 
} from 'react';
import { 
    services,
    hooks,
} from "../.."

export const AuthenticationHook = ( props ) => {

    // authentication service instance
    const _authService  = services.Authentication(props);


    // authentication service
    const {
        store:{
            authUser,
            role,
            _hasHydrated,
        },
        action:{
            verifyToken
        },
        history
    } = _authService

    // redirect to dashboard if user auth is completed
    useEffect(() => {
        // handle invite
      authUser?.role==="admin" && ['/', '/login'].includes(history.location.pathname) && history.push('/admindashboard')
        // && utils.toolkit.navigate.push('/app/main/dashboard')

        authUser?.role==="user" && ['/', '/login'].includes(history.location.pathname) && history.push('/studentdashboard')
        
    }, [authUser]);

    // useEffect(() => {
    //     !authUser && !['/register'].includes(history.location.pathname) && history.push('/login');
    // }, [authUser])

    useEffect(() => {
        const token = new URLSearchParams(history.location.search).get("token");
        if(token && history.location.pathname == "/forgot-password"){
            verifyToken({token}) 
        }
       
        // const currentPath = history.location.pathname;
        // const allowedPath = '/verify';

        // EmailverificationToken && 
        // currentPath === allowedPath && 
        // userEmailVerification({
        //     token: EmailverificationToken
        // });
    }, []);

    return {
        authService: {
            ..._authService
        },
        ...props
    };
}

export const authentication = (props) => AuthenticationHook(hooks.UtilityAndConfig(props))